import React from "react";
import { createContext, useState } from "react";


const DistrictContext = createContext({});

const DistrictContextWrapper = ({ children }) => {
  const [ districtShow, setDistrictShow] = React.useState("All");
  const [allDistrictsData, setAllDistrictsData] = useState([]);
  const [districtDataStateWise, setDistrictDataStateWise] = useState([]);
  const [dotGraphKey, setDotGraphKey] = useState(1);

  const [stateCode, setStateCode] = useState("")


  const dataSet = { districtShow, setDistrictShow, allDistrictsData, setAllDistrictsData, districtDataStateWise, setDistrictDataStateWise, dotGraphKey, setDotGraphKey, stateCode, setStateCode }

  return (
    <DistrictContext.Provider value={dataSet}>
      {children}
    </DistrictContext.Provider>
  );
};

export {DistrictContext, DistrictContextWrapper};




